// modules/inicio/components/RutaPublica.js
// Lo opuesto a RutaPrivada: envuelve páginas que solo tienen sentido SIN
// sesión iniciada (login, restablecer contraseña). Si ya hay un usuario
// logueado, lo manda de vuelta al Home en vez de dejarlo ver el login de
// nuevo — así no se puede "regresar" a /login navegando manualmente o con
// el botón atrás del navegador; la única forma de volver ahí es cerrando
// sesión (logout limpia el user en AuthContext).

import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RutaPublica({ children }) {
  const { user, cargando } = useAuth();

  if (cargando) return null; // evita parpadeo mientras se valida el token guardado

  if (user) return <Navigate to="/" replace />;

  return children;
}
